define('lq/events/actions/webserviceClient',[
    'lq/events/actions/eventAction'
], function(EventAction) {
    'use strict';
        
    function WebserviceClient(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(WebserviceClient, EventAction);

    WebserviceClient.typeName = 'WebserviceClient';

    WebserviceClient.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };
        
    WebserviceClient.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'WebserviceClientCommand',
            command: this.eventData.command
        };
    };

    return WebserviceClient;
});
